<app-breadcrumb [master]="'Rejestracje'" [parentName]="'Identyfikatory'" [name]="'Importuj'"></app-breadcrumb>
<div class="identifier-import" fxLayout="column" fxLayoutGap="15px" [formGroup]="identifierImportForm">
  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100">
      <div fxLayout="row">
        <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100">
          <div fxLayout="row">
            <h3>Dane importu</h3>
          </div>

          <div fxLayout="row" fxFlex="100">
<!--              <div fxLayout="row">-->
<!--              <ngx-mat-file-input-->
<!--                #fileInput-->
<!--                placeholder="Plik importu ({{fileMaxSize | byteFormat}})"-->
<!--                [required]="true"-->
<!--                [formControl]="fileControl"-->
<!--                [multiple]="false"-->
<!--                [accept]="'.xlsx'"-->
<!--                (click)="resetFileValue()"-->
<!--              ></ngx-mat-file-input>-->
            <app-file-drag-and-drop fxFlex="100" [acceptMime]="'.xlsx'"  (fileSelected)="fileSelected($event)"[multiple]="false" [fileControl]="fileControl">
              <mat-icon matSuffix color="accent">attachment</mat-icon>
              <mat-error *ngIf="fileControl.hasError('required')">Wybierz plik</mat-error>
            </app-file-drag-and-drop>
          </div>

          <mat-error *ngIf="fileControl?.hasError('maxContentSize')">
            Całkowity rozmiar pliku nie może przekraczać
            {{fileControl.getError('maxContentSize').maxSize | byteFormat}}
            (Wybrany plik: {{fileControl.getError('maxContentSize').actualSize
            | byteFormat}}).
          </mat-error>
          <mat-error *ngIf="identifierImportForm.get('fileContent')?.hasError('backendError')">
            {{identifierImportForm.get('fileContent').getError('backendError')}}
          </mat-error>

          <div fxLayout="row">
            <mat-form-field fxFlex="100">
              <mat-label>Typ akcji</mat-label>
              <mat-select [formControl]="importTypeControl" [required]="true" [multiple]="false">
                <mat-option value="identifiers">
                  Import identyfikatorów
                </mat-option>
                <mat-option value="affiliateLinks">
                  Import linków afiliacyjnych
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div fxLayout="row">
            <app-dict
              fxFlex="100"
              label="Firma"
              dictType="company"
              [control]="companyControl"
              [required]="true"
            ></app-dict>
          </div>

          <div fxLayout="row">
            <app-dict-insurance-companies
              fxFlex="100" label="TU"
              [required]="true"
              [control]="insuranceCompanyControl"
              [companyId]="importCompanyId"
              (selectedInsuranceCompany)="insuranceCompanyChanged($event)"
            ></app-dict-insurance-companies>
          </div>

          <div fxLayout="row" *ngIf="typeKeys.length > 0 && !affiliateLinksControl.value">
            <app-dict
              fxFlex="100"
              label="Rodzaj identyfikatora"
              [multiple]="true"
              [required]="false"
              dictType="registration_id_type"
              [onlyKeys]="typeKeys"
              [control]="typesControl"
              (selectedMultipleDict)="onTypesChange($event)"
              [autoSelect]="false"
            ></app-dict>
          </div>

          <div fxLayout="row" *ngIf="affiliateLinksControl.value">
            <app-dynamic-dict
              fxFlex="100"
              label="Linki afiliacyjne"
              [multiple]="true"
              [required]="true"
              [returnObject]="true"
              [control]="affiliateLinksTypesControl"
              [dictType]="DYNAMIC_DICTIONARY_AFFILIATE_LINKS">
            </app-dynamic-dict>
          </div>

          <div fxLayout="row">
            <div fxFlex="100" class="slide-padding">
              <mat-slide-toggle color="accent" formControlName="changeToRegistered">
                Czy zmienić status Rejestracji na “Zarejestrowana”, jeśli występuje na raporcie?
              </mat-slide-toggle>
            </div>
          </div>

          <div fxLayout="row">
            <div fxFlex="100" class="slide-padding">
              <mat-slide-toggle color="accent" formControlName="changeToDeregistered">
                Czy zmienić status Rejestracji na “Wyrejestrowana”, jeśli nie występuje na raporcie?
              </mat-slide-toggle>
            </div>
          </div>

          <div fxLayout="row">
            <div fxFlex="100" class="slide-padding">
              <mat-slide-toggle color="accent" [formControl]="fullReportControl">Pełny raport</mat-slide-toggle>
            </div>
          </div>

          <div fxLayout="row">
            <div fxFlex="100" class="slide-padding">
              <mat-slide-toggle color="accent" [formControl]="hiperioBlockedAccountControl">Konto zablokowane</mat-slide-toggle>
            </div>
          </div>

          <div fxLayout="column">
            <div fxLayout="row">
              <h5>Kolejność i nazwy kolumn</h5>
            </div>
            <div fxLayout="row">
              <mat-chip-list>
                <mat-chip  color="accent" selected (click)="copyMessage('PESEL')">
                  PESEL
                </mat-chip>
                <mat-chip   color="accent" selected (click)="copyMessage('RAU')">
                  RAU
                </mat-chip>
                  <mat-chip color="accent" selected *ngFor="let dict of selectedTypes; let last = last" (click)="copyMessage(dict.name)">
                    {{dict.name}}
                  </mat-chip>
                <ng-container *ngIf="chronieLoginControl.value">
                  <mat-chip  color="accent" selected (click)="copyMessage('Login chronie.pl')">
                    Login chronie.pl
                  </mat-chip>
                </ng-container>
                <ng-container *ngIf="hiperioDataControl.value  && !hiperioBlockedAccountControl.value">
                  <mat-chip  color="accent" selected (click)="copyMessage('Login Hiperio')">
                    Login Hiperio
                  </mat-chip>
                  <mat-chip  color="accent" selected (click)="copyMessage('Email Hiperio')">
                    Email Hiperio
                  </mat-chip>
                </ng-container>
                <ng-container *ngIf="hiperioDataControl.value && hiperioBlockedAccountControl.value">
                  <mat-chip  color="accent" selected (click)="copyMessage('Login Hiperio')">
                    Login Hiperio
                  </mat-chip>
                  <mat-chip  color="accent" selected (click)="copyMessage('Email Hiperio')">
                    Email Hiperio
                  </mat-chip>
                  <mat-chip  color="accent" selected (click)="copyMessage('Konto zablokowane')">
                    Konto zablokowane
                  </mat-chip>
                </ng-container>
                <ng-container *ngIf="affiliateLinksSelected.length > 0">
                  <mat-chip color="accent" selected *ngFor="let dict of affiliateLinksSelected; let last = last" (click)="copyMessage(dict.name)">
                    {{dict.name}}
                  </mat-chip>
                </ng-container>
              </mat-chip-list>
            </div>
          </div>
        </mat-card>
      </div>
    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" *ngIf="registrationIdImport && registrationIdImport.progress !== 100">
      <div fxLayout="row">
        <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100">
          <div fxLayout="row">
            <h3>Importowanie</h3>
          </div>

          <div fxLayout="row">
            <mat-progress-bar mode="determinate" [value]="registrationIdImport.progress"></mat-progress-bar>
          </div>

        </mat-card>
      </div>
    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" *ngIf="registrationIdImport && registrationIdImport.progress === 100">
      <div fxLayout="row">
        <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100">
          <div fxLayout="row">
            <h3>Wynik</h3>
          </div>

          <app-detail fxFlex="100" header="Wyrejestrowane" [value]="registrationIdImport.result.deregistered.toString()"></app-detail>

          <app-detail fxFlex="100" header="Nieznalezione PESEL">
            <ng-container *ngFor="let pesel of registrationIdImport.result.notFoundPesel; let last = last">
              {{pesel}}<ng-container *ngIf="!last">, </ng-container>
            </ng-container>
          </app-detail>

          <app-detail fxFlex="100" header="Nieznalezione RAU">
            <ng-container *ngFor="let rau of registrationIdImport.result.notFoundRau; let last = last">
              {{rau}}<ng-container *ngIf="!last">, </ng-container>
            </ng-container>
          </app-detail>

          <app-detail fxFlex="100" header="Nieznalezione rejestracje">
            <ng-container *ngFor="let pesel of registrationIdImport.result.notFoundRegistration; let last = last">
              {{pesel}}<ng-container *ngIf="!last">, </ng-container>
            </ng-container>
          </app-detail>

          <app-detail fxFlex="100" header="Duplikaty PESEL">
            <ng-container *ngFor="let pesel of registrationIdImport.result.duplicatedPesel; let last = last">
              {{pesel}}<ng-container *ngIf="!last">, </ng-container>
            </ng-container>
          </app-detail>

          <app-detail fxFlex="100" header="Duplikaty RAU">
            <ng-container *ngFor="let rau of registrationIdImport.result.duplicatedRau; let last = last">
              {{rau}}<ng-container *ngIf="!last">, </ng-container>
            </ng-container>
          </app-detail>

          <app-detail fxFlex="100" header="Duplikaty rejestracji">
            <ng-container *ngFor="let pesel of registrationIdImport.result.duplicatedRegistration; let last = last">
              {{pesel}}<ng-container *ngIf="!last">, </ng-container>
            </ng-container>
          </app-detail>

        </mat-card>
      </div>
    </div>
  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="import()" [class.spinner]="processingRequest"
            [disabled]="!identifierImportFormValid"
            mat-stroked-button color="primary"><mat-icon>publish</mat-icon> <span> Importuj</span></button>
  </div>
</div>
